import { CONTACT, SOCIAL_LINKS, WHATSAPP_MESSAGES } from '../../../core/constants/site';
import { buildWhatsAppUrl } from '../../../core/utils/whatsapp';
import {
    IconClock,
    IconFacebook,
    IconInstagram,
    IconLinkedIn,
    IconMail,
    IconMapPin,
    IconPhone,
    IconWhatsApp,
    IconYouTube,
} from '../../../common/icons';
import Reveal from '../../../common/components/Reveal/Reveal';

import '../styles/contact.css';

const SOCIAL_ICONS = {
    instagram: IconInstagram,
    facebook: IconFacebook,
    youtube: IconYouTube,
    linkedin: IconLinkedIn,
};

export default function Contact() {
    const whatsappHref = buildWhatsAppUrl(WHATSAPP_MESSAGES.quote);

    return (
        <section id="contacto" className="contact section" aria-labelledby="contact-title">
            <div className="contact__inner container">
                <Reveal className="contact__intro">
                    <p className="eyebrow">Contacto</p>
                    <h2 id="contact-title" className="section__title">Hablemos de tu proyecto</h2>
                    <p className="section__lead">
                        WhatsApp es nuestro canal principal de atención. También atendemos por
                        teléfono y correo.
                    </p>

                    <a className="button button--whatsapp contact__cta" href={whatsappHref} target="_blank" rel="noopener">
                        <IconWhatsApp />
                        Cotiza tu proyecto por WhatsApp
                    </a>

                    <ul className="contact__social" aria-label="Redes sociales">
                        {SOCIAL_LINKS.map(link => {
                            const SocialIcon = SOCIAL_ICONS[link.id];
                            return (
                                <li key={link.id}>
                                    <a
                                        className="contact__social-link"
                                        href={link.href}
                                        target="_blank"
                                        rel="noopener"
                                        aria-label={link.label}
                                    >
                                        <SocialIcon />
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </Reveal>

                <Reveal as="address" className="contact__details">
                    <dl className="contact__list">
                        <div className="contact__row">
                            <dt className="contact__term"><IconWhatsApp size={18} />WhatsApp</dt>
                            <dd className="contact__value">
                                <a className="contact__link" href={whatsappHref} target="_blank" rel="noopener">
                                    {CONTACT.whatsappDisplay}
                                </a>
                            </dd>
                        </div>

                        <div className="contact__row">
                            <dt className="contact__term"><IconPhone size={18} />Teléfonos</dt>
                            <dd className="contact__value">
                                {CONTACT.phones.map(phone => (
                                    <a className="contact__link" href={phone.href} key={phone.href}>
                                        {phone.display}
                                    </a>
                                ))}
                            </dd>
                        </div>

                        <div className="contact__row">
                            <dt className="contact__term"><IconMail size={18} />Correo</dt>
                            <dd className="contact__value">
                                <a className="contact__link" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                            </dd>
                        </div>

                        <div className="contact__row">
                            <dt className="contact__term"><IconMapPin size={18} />Dirección</dt>
                            <dd className="contact__value">
                                <a className="contact__link" href={CONTACT.mapsHref} target="_blank" rel="noopener">
                                    {CONTACT.address}
                                </a>
                                <span className="contact__hint">{CONTACT.addressCity}</span>
                            </dd>
                        </div>

                        <div className="contact__row">
                            <dt className="contact__term"><IconClock size={18} />Horario</dt>
                            <dd className="contact__value">
                                <span>{CONTACT.hours}</span>
                                {!CONTACT.isHoursConfirmed && (
                                    <span className="contact__pending">Por confirmar</span>
                                )}
                            </dd>
                        </div>
                    </dl>
                </Reveal>
            </div>
        </section>
    );
}
